@if (!timeSeriesPerformanceStore.analysisErrorState) {
  <ul class="grid grid-cols-1 mt-4 select-none cursor-default"
      role="list">
    <li class="overflow-hidden rounded-xl border border-gray-200">
      <div class="flex justify-between gap-x-4 border-b border-gray-900/5 bg-gray-50 p-6 pb-2">
        <span class="text-2xl font-thin">Zeitraum</span>
        <div class="grid grid-rows-2">
        <span
          class="text-2xl font-medium">{{ TimeUtilities.formatAsTodayOrFullDate(timeSeriesPerformanceStore.getStartTime()) }}
          - {{ TimeUtilities.formatAsTodayOrFullDate(timeSeriesPerformanceStore.getEndTime()) }}</span>
          <span class="text-end font-thin">({{ timeSeriesPerformanceStore.getStartTime() | date : "HH:mm" }}
            - {{ timeSeriesPerformanceStore.getEndTime() | date : "HH:mm" }} Uhr)</span>
        </div>


      </div>


      @if (isScreenSmallerThan(1024)) {
        <dl class="-my-3 divide-y divide-gray-100 px-6 py-4 text-sm leading-6">
          <div class="flex justify-between gap-x-4 py-3">
            <dt class="text-gray-500">Umsatz</dt>
            <dd class="flex items-start gap-x-2">
              @if (timeSeriesPerformanceStore.getRevenue()) {
                <div class="font-medium text-gray-900">{{ timeSeriesPerformanceStore.getRevenue() | currency: "EUR" }}
                </div>
              }
            </dd>
          </div>
          <div class="flex justify-between gap-x-4 py-3">
            <dt class="text-gray-500">Bestellungen</dt>
            <dd class="flex items-start gap-x-2">
              @if (timeSeriesPerformanceStore.getQuantity()) {
                <div class="font-medium text-gray-900">{{ timeSeriesPerformanceStore.getQuantity() | number }}
                </div>
              }
            </dd>
          </div>
          @if (timeSeriesPerformanceStore.getEventCount()) {
            <div class="flex justify-between gap-x-4 py-3">
              <dt class="text-gray-500">Events</dt>
              <dd class="flex items-start gap-x-2">
                <div class="font-medium text-gray-900">{{ timeSeriesPerformanceStore.getEventCount() }}</div>
              </dd>
            </div>
          }
        </dl>
      }
    </li>
  </ul>
}
@if (!timeSeriesPerformanceStore.analysisErrorState && !isScreenSmallerThan(1024)) {
  <ul class="grid grid-cols-1 gap-x-6 gap-y-3 lg:grid-cols-3 xl:gap-x-8 mt-3"
      role="list">
    <li class="overflow-hidden rounded-xl border border-gray-200 select-none cursor-default">
      <div class="flex items-center gap-x-4 border-b border-gray-900/5 bg-gray-50 p-6">
        <svg class="bi bi-graph-up-arrow h-6 w-6 " viewBox="0 0 16 16"
             xmlns="http://www.w3.org/2000/svg">
          <path
            d="M0 0h1v15h15v1H0zm10 3.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V4.9l-3.613 4.417a.5.5 0 0 1-.74.037L7.06 6.767l-3.656 5.027a.5.5 0 0 1-.808-.588l4-5.5a.5.5 0 0 1 .758-.06l2.609 2.61L13.445 4H10.5a.5.5 0 0 1-.5-.5"
            fill-rule="evenodd"/>
        </svg>
        <div class="text-sm font-medium leading-6 text-gray-900">Umsatz</div>
        <div class="relative ml-auto">

        </div>
      </div>
      <dl class="-my-3   px-6 py-4 text-sm leading-6">

        <div class="flex justify-between gap-x-4 py-3">
          <dt class="text-gray-500">Umsatz</dt>
          <dd
            class="font-medium text-gray-900">{{ timeSeriesPerformanceStore.orderRepository.totalRevenue | currency: "EUR" }}
          </dd>
        </div>
        <table class="w-full border-t-2 border-b-2 border-grey-900" style="padding: .5rem .5rem;">
          <tr class="">
            <th class="text-gray-500   ">
              <div class="  px-0">Steuern</div>
            </th>
            <td class="text-right py-2">
              <div
                class=" text-gray-900 px-0 ">{{ -(timeSeriesPerformanceStore.isNetRevenue ? timeSeriesPerformanceStore.orderRepository.totalTaxes : 0) | currency: "EUR" }}
              </div>
            </td>
          </tr>
          <tr class="">
            <th class="text-gray-500  ">
              <div class="  px-0">Personalkosten</div>
            </th>
            <td class="text-right py-2">
              <div
                class=" text-gray-900 px-0 ">{{ (timeSeriesPerformanceStore.isEmployeeCostsIncluded ? -timeSeriesPerformanceStore.employmentCostRepository.totalEmploymentCost : 0) | currency: "EUR" }}
              </div>
            </td>
          </tr>
        </table>
        <div class="flex justify-between gap-x-4 py-3">
          <dt class="text-gray-500">vorl. Gewinn</dt>
          <dd class="font-medium text-gray-900">
            = {{ timeSeriesPerformanceStore.orderRepository.totalRevenue - (timeSeriesPerformanceStore.isNetRevenue ? timeSeriesPerformanceStore.orderRepository.totalTaxes : 0) - (timeSeriesPerformanceStore.isEmployeeCostsIncluded ? timeSeriesPerformanceStore.employmentCostRepository.totalEmploymentCost : 0) | currency: "EUR" }}
          </dd>
        </div>
      </dl>
    </li>

    <li class="overflow-hidden rounded-xl border border-gray-200 select-none">
      <div class="flex items-center gap-x-4 border-b border-gray-900/5 bg-gray-50 p-6 ">
        <svg class="bi bi-clipboard2-data h-6 w-6 " height="16" viewBox="0 0 16 16"
             width="16" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M9.5 0a.5.5 0 0 1 .5.5.5.5 0 0 0 .5.5.5.5 0 0 1 .5.5V2a.5.5 0 0 1-.5.5h-5A.5.5 0 0 1 5 2v-.5a.5.5 0 0 1 .5-.5.5.5 0 0 0 .5-.5.5.5 0 0 1 .5-.5z"/>
          <path
            d="M3 2.5a.5.5 0 0 1 .5-.5H4a.5.5 0 0 0 0-1h-.5A1.5 1.5 0 0 0 2 2.5v12A1.5 1.5 0 0 0 3.5 16h9a1.5 1.5 0 0 0 1.5-1.5v-12A1.5 1.5 0 0 0 12.5 1H12a.5.5 0 0 0 0 1h.5a.5.5 0 0 1 .5.5v12a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5z"/>
          <path
            d="M10 7a1 1 0 1 1 2 0v5a1 1 0 1 1-2 0zm-6 4a1 1 0 1 1 2 0v1a1 1 0 1 1-2 0zm4-3a1 1 0 0 0-1 1v3a1 1 0 1 0 2 0V9a1 1 0 0 0-1-1"/>
        </svg>
        <div class="text-sm font-medium leading-6 text-gray-900">Statistiken</div>
        <div class="relative ml-auto">
          <div class="flex place-self-center ">
            <label class="sr-only" for="statitisticSelection">Anzeigeoption</label>
            <select (ngModelChange)="statisticsOverviewOption = $event" [ngModel]="statisticsOverviewOption"
                    class="cursor-pointer block w-full rounded-md border-0 py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    id="statitisticSelection" name="statitisticSelection">
              <option [value]="CombinedOrderElementDtoKeys.locationId">Umsatz pro
                Standort
              </option>
              <option [value]="CombinedOrderElementDtoKeys.compositionTypeId"
              >Umsatz pro
                Kategorie
              </option>
              <option [value]="CombinedOrderElementDtoKeys.bookingType"
              >Umsatz pro
                Zahlungsmethode
              </option>
            </select>
          </div>
        </div>
      </div>
      <dl class="-my-3 px-6 py-4 text-sm leading-6 ">
        <div class="flex justify-between gap-x-4 py-2 cursor-default">
          <dt class="text-gray-500">Umsatz pro Arbeitsstunde</dt>
          <dd
            class="text-gray-700">{{ timeSeriesPerformanceStore.orderRepository.totalRevenue / timeSeriesPerformanceStore.employmentCostRepository.totalEmployeeHours | currency: "EUR" }}
          </dd>
        </div>

        <div class="flex justify-between gap-x-4 py-2 cursor-default">
          <dt class="text-gray-500">Verkaufte Artikel</dt>
          <dd class="text-gray-700">{{ timeSeriesPerformanceStore.orderRepository.totalQuantity }}</dd>
        </div>

        <div class="flex justify-between gap-x-4 py-2  cursor-default">
          <dt class="text-gray-500">Events</dt>
          <dd class="text-gray-700">{{ timeSeriesPerformanceStore.eventRepository.events.length }}</dd>
        </div>

        <table class="w-full border-t-2 border-grey-900 select-text" style="padding: .5rem .5rem;">
          <ng-container *ngFor="let revenueOfGroup of getStatisticsGroup(statisticsOverviewOption)">
            <tr class="">
              <th class="text-gray-500 cursor-default w-full">
                <div
                  class=" px-0">{{ timeSeriesPerformanceStore.linkedDtoRepository.getName(revenueOfGroup.filter.value, statisticsOverviewOption) }}
                </div>
              </th>
              <td class="text-right py-2">
                <div class="inline-flex">
                  <div
                    class=" text-gray-900 px-0 cursor-default">{{ getRevenue(revenueOfGroup.filter.value, statisticsOverviewOption) | currency: "EUR" }}
                  </div>
                  <input
                    (ngModelChange)="setStatisticsOverviewOption(statisticsOverviewOption, revenueOfGroup.filter.value, $event)"
                    [id]="'cb_' + revenueOfGroup.filter.value+'_'+statisticsOverviewOption"
                    [ngModel]="getStatisticsGroupModel(statisticsOverviewOption, revenueOfGroup.filter.value).isActive"
                    class="my-auto h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600 cursor-pointer ml-2 select-none"
                    type="checkbox">
                </div>
              </td>
            </tr>
          </ng-container>
        </table>
      </dl>
    </li>

    <li class="overflow-hidden rounded-xl border border-gray-200 cursor-default select-none">
      <div class="flex items-center gap-x-4 border-b border-gray-900/5 bg-gray-50 p-6">
        <svg class="bi bi-gear h-6 w-6" height="16" viewBox="0 0 16 16" width="16"
             xmlns="http://www.w3.org/2000/svg">
          <path
            d="M8 4.754a3.246 3.246 0 1 0 0 6.492 3.246 3.246 0 0 0 0-6.492M5.754 8a2.246 2.246 0 1 1 4.492 0 2.246 2.246 0 0 1-4.492 0"/>
          <path
            d="M9.796 1.343c-.527-1.79-3.065-1.79-3.592 0l-.094.319a.873.873 0 0 1-1.255.52l-.292-.16c-1.64-.892-3.433.902-2.54 2.541l.159.292a.873.873 0 0 1-.52 1.255l-.319.094c-1.79.527-1.79 3.065 0 3.592l.319.094a.873.873 0 0 1 .52 1.255l-.16.292c-.892 1.64.901 3.434 2.541 2.54l.292-.159a.873.873 0 0 1 1.255.52l.094.319c.527 1.79 3.065 1.79 3.592 0l.094-.319a.873.873 0 0 1 1.255-.52l.292.16c1.64.893 3.434-.902 2.54-2.541l-.159-.292a.873.873 0 0 1 .52-1.255l.319-.094c1.79-.527 1.79-3.065 0-3.592l-.319-.094a.873.873 0 0 1-.52-1.255l.16-.292c.893-1.64-.902-3.433-2.541-2.54l-.292.159a.873.873 0 0 1-1.255-.52zm-2.633.283c.246-.835 1.428-.835 1.674 0l.094.319a1.873 1.873 0 0 0 2.693 1.115l.291-.16c.764-.415 1.6.42 1.184 1.185l-.159.292a1.873 1.873 0 0 0 1.116 2.692l.318.094c.835.246.835 1.428 0 1.674l-.319.094a1.873 1.873 0 0 0-1.115 2.693l.16.291c.415.764-.42 1.6-1.185 1.184l-.291-.159a1.873 1.873 0 0 0-2.693 1.116l-.094.318c-.246.835-1.428.835-1.674 0l-.094-.319a1.873 1.873 0 0 0-2.692-1.115l-.292.16c-.764.415-1.6-.42-1.184-1.185l.159-.291A1.873 1.873 0 0 0 1.945 8.93l-.319-.094c-.835-.246-.835-1.428 0-1.674l.319-.094A1.873 1.873 0 0 0 3.06 4.377l-.16-.292c-.415-.764.42-1.6 1.185-1.184l.292.159a1.873 1.873 0 0 0 2.692-1.115z"/>
        </svg>
        <div class="text-sm font-medium leading-6 text-gray-900">Einstellungen</div>
        <div class="relative ml-auto">

        </div>
      </div>
      <dl class="-my-3 divide-y divide-gray-100 px-6 py-4 text-sm leading-6 ">
        <div class="flex justify-between gap-x-4 py-3">
          <dt class="text-gray-500">Netto</dt>
          <dd class="text-gray-700">
            <app-switch-medium (isOnChange)="netRevenueToggle($event)" [isOn]="timeSeriesPerformanceStore.isNetRevenue"
                               class="my-auto">

            </app-switch-medium>
          </dd>
        </div>
        <div class="flex justify-between gap-x-4 py-3">
          <dt class="text-gray-500">Mitarbeiterverkäufe ignorieren</dt>
          <dd class="text-gray-700">
            <app-switch-medium (isOnChange)="timeSeriesPerformanceStore.toggleBookingTypeEmployeeSalesFilter($event)"
                               [isOn]="timeSeriesPerformanceStore.isBookingTypeEmployeeSalesIncluded"
                               class="my-auto">

            </app-switch-medium>
          </dd>
        </div>
        <div class="flex justify-between gap-x-4 py-3 ">
          <dt class="text-gray-500">Personalkosten inkludieren</dt>
          <dd class="flex items-start gap-x-2">
            <app-switch-medium (isOnChange)="timeSeriesPerformanceStore.toggleEmployeeCosts($event)"
                               [isOn]="timeSeriesPerformanceStore.isEmployeeCostsIncluded"
                               class="my-auto"></app-switch-medium>
          </dd>
        </div>
      </dl>
    </li>
  </ul>
}

<div>
  <div class="divide-y divide-gray-200 overflow-hidden mt-5 bg-white shadow sm:rounded-lg ">
    <div class="px-4 py-4 sm:px-6 inline-flex w-full justify-between select-none cursor-default">
      <span class="text-2xl leading-6  text-gray-900">
        {{ timeSeriesBarChartStore.isBarChartTrendEnabled ? 'Trend Zahlungsmittel' : 'Umsatz' }}
      </span>
      <div class="flex text-center ">

        <span class="text-gray-500 my-auto  pr-2 text-sm">Trend</span>
        <app-switch-medium (isOnChange)="switchBarChartTrend($event)"
                           [isOn]="timeSeriesBarChartStore.isBarChartTrendEnabled "
                           class="mt-1"></app-switch-medium>

      </div>
    </div>
    <div>
      @if (timeSeriesBarChartStore.isBarChartTrendEnabled) {
        <analytics-relative-time-series-chart #multiEventRevenueChart
                                              [ngClass]="{'hidden':!timeSeriesBarChartStore.isBarChartTrendEnabled}"/>
      } @else {
        <analytics-revenue-time-series-chart #multiEventTrendChart
                                             [ngClass]="{'hidden': timeSeriesBarChartStore.isBarChartTrendEnabled}"/>
      }
    </div>
  </div>
  <div class="divide-y divide-gray-200 overflow-hidden mt-5 bg-white shadow sm:rounded-lg">
    <div class="px-4 py-4 sm:px-6 select-none cursor-default">
    <span class="text-2xl leading-6  text-gray-900 flex w-full justify-between">
      <div>Umsatzaufteilung</div>
      <!--Todo implement onNegativeRevenue-->
    </span>
    </div>
    <div class="px-4 pb-3.5 pt-4 sm:p-6">

      <div class="md:grid md:grid-cols-2 md:gap-x-3">
        <analytics-revenue-doughnut-chart #doughnutRevenueChart
                                          [hoverModel]="{id: 'pieChart', selfIdentifier: 'revenueDoughnutChart'}"></analytics-revenue-doughnut-chart>
        <analytics-percent-ul-card #percentCard
                                   [hoverModel]="{id: 'pieChart', selfIdentifier: 'revenueDoughnutChartMakeUp'}"
                                   class="my-auto"></analytics-percent-ul-card>

        <!--
          <app-revenue-doughnut-chart #doughnutRevenueChart [hoverModel]="{id: 'pieChart', selfIdentifier: 'revenueDoughnutChart'}" [invalidAnalysisErrorCode]="timeSeriesPerformanceStore.invalidAnalysisErrorCode"></app-revenue-doughnut-chart>
          <app-percent-ui-card [hoverModel]="{id: 'pieChart', selfIdentifier: 'revenueDoughnutChartMakeUp'}" #percentCard  class="my-auto"></app-percent-ui-card>
        -->
      </div>
    </div>
  </div>
  <app-tab-selection class="mt-3.5 block" (optionSelected)="setDoughnutRevenueChartDisplayOption($event)"
                     [options]="doughnutRevenueChartDisplayOptions"
                     [selectedOption]="doughnutRevenueChartDisplayOptions[0]"></app-tab-selection>

  <analytics-event-overview-table #eventOverviewTable style="margin-bottom: -7rem;"></analytics-event-overview-table>

</div>

